import React, { Component, Fragment } from "react";
import { Route, Switch } from "react-router";
import AboutPage from "../pages/AboutPage";
import ContactPage from "../pages/ContactPage";
import HomePage from "../pages/HomePage";
import PolicyPage from "../pages/PolicyPage";
import PurchasePage from "../pages/PurchasePage";
import RefundPage from "../pages/RefundPage";
import VisaService from "../pages/VisaPage";
import BlogPage from "../pages/packages/Blog/BlogPage";
import GalleryPage from "../pages/packages/Gallery/GalleryPage";
import BhutanGalleryInsidePage from "../pages/packages/Gallery/BhutanGalleryInsidePage";
import AdventureTourLadakhToSikkimPage from "../pages/packages/AdventureTourLadakhToSikkimPage";
import BhutanTourPackagePage from "../pages/packages/Bhutan/BhutanTourPackagePage";
import FIFO_5N_6D_Page from "../pages/packages/Bhutan/FIFO_5N_6D_Page";
import FIFO_4N_5D_Page from "../pages/packages/Bhutan/FIFO_4N_5D_Page";
import FIFO_6N_7D_Page from "../pages/packages/Bhutan/FIFO_6N_7D_Page";
import FIFO_7N_8D_Page from "../pages/packages/Bhutan/FIFO_7N_8D_Page";
import FIFO_8N_9D_Page from "../pages/packages/Bhutan/FIFO_8N_9D_Page";
import FIFO_10N_11D_Page from "../pages/packages/Bhutan/FIFO_10N_11D_Page";
import DelhiToBhutanPage from "../pages/packages/Bhutan/DelhiToBhutanPage";
import MumbaiToBhutanPage from "../pages/packages/Bhutan/MumbaiToBhutanPage";
import KolkataToBhutanPage from "../pages/packages/Bhutan/KolkataToBhutanPage";
import ChennaiToBhutanPage from "../pages/packages/Bhutan/ChennaiToBhutanPage";
import HyderabadToBhutanPage from "../pages/packages/Bhutan/HyderabadToBhutanPage";
import AhemdabadToBhutanPage from "../pages/packages/Bhutan/AhemdabadToBhutanPage";
import PuneToBhutanPage from "../pages/packages/Bhutan/PuneToBhutanPage";
import BangaloreToBhutanPackage from "../pages/packages/Bhutan/BangaloreToBhutanPage";
import Bagdogra_6N_7D_Page from "../pages/packages/Bhutan/Bagdogra_6N_7D_Page";
import SuratToBhutanPage from "../pages/packages/Bhutan/SuratToBhutanPage";
import Bhutan_B2B_7N_8D_Page from "../pages/packages/Bhutan/Bhutan_B2B_7N_8D_Page";
import Bhutan_TourGuwahatiPage from "../pages/packages/Bhutan/Bhutan_TourGuwahatiPage";
import Bhutan_TourSixsenseHotelPage from "../pages/packages/Bhutan/Bhutan_TourSixsenseHotelPage";
import Bhutan_TourSixsenseDirectFlightIndiaPage from "../pages/packages/Bhutan/Bhutan_TourSixsenseDirectFlightIndiaPage";
import Bhutan_TourHasimaraNoqPage from "../pages/packages/Bhutan/Bhutan_TourHasimaraNoqPage";
import Bhutan_TourPhuentsholingPage from "../pages/packages/Bhutan/Bhutan_TourPhuentsholingPage";
import Bhutan_TourNjpSiliguriPage from "../pages/packages/Bhutan/Bhutan_TourNjpSiliguriPage";
import Bhutan_TourJaigaonPage from "../pages/packages/Bhutan/Bhutan_TourJaigaonPage";
import BangaloreToBhutanviaKolkataAirportPage from "../pages/packages/Bhutan/BangaloreToBhutanviaKolkataAirportPage";
import Bhutan_B2B_7N_8D_Bagdogra_Airport_Page from "../pages/packages/Bhutan/Bhutan_B2B_7N_8D_Bagdogra_Airport_Page";
import Bagdogra_7N_8D_Group_Page from "../pages/packages/Bhutan/Bagdogra_7N_8D_Group_Page";
import Bhutan_Nagpur_6N_7D_Page from "../pages/packages/Bhutan/Bhutan_Nagpur_6N_7D_Page";
import Bhutan_Nashik_6N_7D_Page from "../pages/packages/Bhutan/Bhutan_Nashik_6N_7D_Page";
import Bhutan_Bhopal_6N_7D_Page from "../pages/packages/Bhutan/Bhutan_Bhopal_6N_7D_Page";
import EasternBhutanPage from "../pages/packages/Bhutan/EasternBhutanPage";
import Bhutan_10N_11D_Page from "../pages/packages/Bhutan/Bhutan_10N_11D_Page";
import Bhutan_9N_10D_Page from "../pages/packages/Bhutan/Bhutan_9N_10D_Page";
import Bhutan_8N_9D_Page from "../pages/packages/Bhutan/Bhutan_8N_9D_Page";
import Bhutan_7N_8D_Page from "../pages/packages/Bhutan/Bhutan_7N_8D_Page";
import Bhutan_6N_7D_Page from "../pages/packages/Bhutan/Bhutan_6N_7D_Page";
import Bhutan_5N_6D_Page from "../pages/packages/Bhutan/Bhutan_5N_6D_Page";
import Bhutan_4N_5D_Page from "../pages/packages/Bhutan/Bhutan_4N_5D_Page";
import BagdograToMysorePage from "../pages/packages/Bhutan/BagdograToMysorePage";
import BagdograToGoaPage from "../pages/packages/Bhutan/BagdograToGoaPage";
import BagdograToBhubaneswarPage from "../pages/packages/Bhutan/BagdograToBhubaneswarPage";
import BagdograToCoimbatorePage from "../pages/packages/Bhutan/BagdograToCoimbatorePage";
import BagdograToJaipurPage from "../pages/packages/Bhutan/BagdograToJaipurPage";
import BagdograToJamnagarPage from "../pages/packages/Bhutan/BagdograToJamnagarPage";
import BagdograToKochiPage from "../pages/packages/Bhutan/BagdograToKochiPage";
import BagdograToLucknowPage from "../pages/packages/Bhutan/BagdograToLucknowPage";
import BagdograToPatnaPage from "../pages/packages/Bhutan/BagdograToPatnaPage";
import BagdograToRajkotPage from "../pages/packages/Bhutan/BagdograToRajkotPage";
import BagdograToRanchiPage from "../pages/packages/Bhutan/BagdograToRanchiPage";
import BagdograToChandigarhPage from "../pages/packages/Bhutan/BagdograToChandigarhPage";
import BagdograToThiruvananthapuramPage from "../pages/packages/Bhutan/BagdograToThiruvananthapuramPage";
import Bhutan_Delhi_ex_8N_9D_Page from "../pages/packages/Bhutan/Bhutan_Delhi_ex_8N_9D_Page";
import Bhutan_Delhi_ex_9N_10D_Page from "../pages/packages/Bhutan/Bhutan_Delhi_ex_9N_10D_Page";
import Bhutan_Delhi_ex_10N_11D_Page from "../pages/packages/Bhutan/Bhutan_Delhi_ex_10N_11D_Page";
import Bhutan_Delhi_ex_7N_8D_Page from "../pages/packages/Bhutan/Bhutan_Delhi_ex_7N_8D_Page";
import Bhutan_Delhi_ex_6N_7D_Page from "../pages/packages/Bhutan/Bhutan_Delhi_ex_6N_7D_Page";
import Bhutan_Delhi_ex_5N_6D_Page from "../pages/packages/Bhutan/Bhutan_Delhi_ex_5N_6D_Page";
import Bhutan_Delhi_ex_4N_5D_Page from "../pages/packages/Bhutan/Bhutan_Delhi_ex_4N_5D_Page";
import Bhutan_Kolkata_ex_4N_5D_Page from "../pages/packages/Bhutan/Bhutan_Kolkata_ex_4N_5D_Page";
import Bhutan_Kolkata_ex_5N_6D_Page from "../pages/packages/Bhutan/Bhutan_Kolkata_ex_5N_6D_Page";
import Bhutan_Kolkata_ex_6N_7D_Page from "../pages/packages/Bhutan/Bhutan_Kolkata_ex_6N_7D_Page";
import Bhutan_Kolkata_ex_7N_8D_Page from "../pages/packages/Bhutan/Bhutan_Kolkata_ex_7N_8D_Page";
import Bhutan_Kolkata_ex_8N_9D_Page from "../pages/packages/Bhutan/Bhutan_Kolkata_ex_8N_9D_Page";
import Bhutan_Kolkata_ex_9N_10D_Page from "../pages/packages/Bhutan/Bhutan_Kolkata_ex_9N_10D_Page";
import Bhutan_Kolkata_ex_10N_11D_Page from "../pages/packages/Bhutan/Bhutan_Kolkata_ex_10N_11D_Page";
import Bhutan_woman_spl_Page from "../pages/packages/Bhutan/Bhutan_woman_spl_Page";
// Blog url-------------------------------------------------------------
import Bhutan_blog_Page from "../pages/packages/Blog/Bhutan_blog_Page";
// meghalaya url-----------------------------------------------------------------
import MeghalayaTourPackagePage from "../pages/packages/Meghalaya/MeghalayaTourPackagePage";
import Meghalaya_5N_6D_Page from "../pages/packages/Meghalaya/Meghalaya_5N_6D_Page";
import Meghalaya_6N_7D_Page from "../pages/packages/Meghalaya/Meghalaya_6N_7D_Page";
import Meghalaya_7N_8D_Page from "../pages/packages/Meghalaya/Meghalaya_7N_8D_Page";
import ShillongMeghalayaTour_6N_7D_Page from "../pages/packages/Meghalaya/ShillongMeghalayaTour_6N_7D_Page";
import KazirangaShillongMeghalayaTour_7N_8D_Page from "../pages/packages/Meghalaya/KazirangaShillongMeghalayaTour_7N_8D_Page";

import MeghalayaArunachalTour_12N_13D_Page from "../pages/packages/Arunachal_Pradesh/MeghalayaArunachalTour_12N_13D_Page";
import MeghalayaShillongCherrapunjeeTour_7N_8D_Page from "../pages/packages/Meghalaya/MeghalayaShillongCherrapunjeeTour_7N_8D_Page";
import Meghalaya_WariChora_Tura_7N_8D_Page from "../pages/packages/Meghalaya/Meghalaya_WariChora_Tura_7N_8D_Page";
import Assam_Meghalaya_Arunachal_19N_20D_Page from "../pages/packages/Meghalaya/Assam_Meghalaya_Arunachal_19N_20D_Page";
import KazirangaShillongCherrapunjeeGroupTour_8N_9D_Page from "../pages/packages/Meghalaya/KazirangaShillongCherrapunjeeGroupTour_8N_9D_Page";
import KazirangaTourWithElephantSafari_7N_8D_Page from "../pages/packages/Meghalaya/KazirangaTourWithElephantSafari_7N_8D_Page";

//North East Packages
import NorthEastIndiaTour_10N_11D_Page from "../pages/packages/Meghalaya/NorthEastIndiaTour_10N_11D_Page";
import NorthEastMumbaiTour_10N_11D_Page from "../pages/packages/Meghalaya/NorthEastMumbaiTour_10N_11D_Page";
import NorthEastAhmedabadTour_10N_11D_Page from "../pages/packages/Meghalaya/NorthEastAhmedabadTour_10N_11D_Page";
import NorthEastBhubaneswarTour_10N_11D_Page from "../pages/packages/Meghalaya/NorthEastBhubaneswarTour_10N_11D_Page";
import NorthEastBangaloreTour_10N_11D_Page from "../pages/packages/Meghalaya/NorthEastBangaloreTour_10N_11D_Page";
import NorthEastChandigarhTour_10N_11D_Page from "../pages/packages/Meghalaya/NorthEastChandigarhTour_10N_11D_Page";
import NorthEastChennaiTour_10N_11D_Page from "../pages/packages/Meghalaya/NorthEastChennaiTour_10N_11D_Page";
import NorthEastDelhiTour_10N_11D_Page from "../pages/packages/Meghalaya/NorthEastDelhiTour_10N_11D_Page";
import NorthEastHyderabadTour_10N_11D_Page from "../pages/packages/Meghalaya/NorthEastHyderabadTour_10N_11D_Page";
import NorthEastJaipurTour_10N_11D_Page from "../pages/packages/Meghalaya/NorthEastJaipurTour_10N_11D_Page";
import NorthEastKolkataTour_10N_11D_Page from "../pages/packages/Meghalaya/NorthEastKolkataTour_10N_11D_Page";
import NorthEastNagpurTour_10N_11D_Page from "../pages/packages/Meghalaya/NorthEastNagpurTour_10N_11D_Page";
import NorthEastNashikTour_10N_11D_Page from "../pages/packages/Meghalaya/NorthEastNashikTour_10N_11D_Page";
import NorthEastPatnaTour_10N_11D_Page from "../pages/packages/Meghalaya/NorthEastPatnaTour_10N_11D_Page";
import NorthEastPuneTour_10N_11D_Page from "../pages/packages/Meghalaya/NorthEastPuneTour_10N_11D_Page";
import NorthEastRajkotTour_10N_11D_Page from "../pages/packages/Meghalaya/NorthEastRajkotTour_10N_11D_Page";
import NorthEastRanchiTour_10N_11D_Page from "../pages/packages/Meghalaya/NorthEastRanchiTour_10N_11D_Page";
import NorthEastSuratTour_10N_11D_Page from "../pages/packages/Meghalaya/NorthEastSuratTour_10N_11D_Page";
import NorthEastVadodaraTour_10N_11D_Page from "../pages/packages/Meghalaya/NorthEastVadodaraTour_10N_11D_Page";
import NorthEastKochiTour_10N_11D_Page from "../pages/packages/Meghalaya/NorthEastKochiTour_10N_11D_Page";
import NorthEastGoaTour_10N_11D_Page from "../pages/packages/Meghalaya/NorthEastGoaTour_10N_11D_Page";
//sikkim
import NorthSikkim_2N_3D_Gangtok_Page from "../pages/packages/Sikkim_Darjeeling/NorthSikkim_2N_3D_Gangtok_Page";
import Sikkim_Darjeeling_4N_5D_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Darjeeling_4N_5D_Page";
import Sikkim_5N_6D_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_5N_6D_Page";
import NorthSikkim_Silkroute_8N_9D_Page from "../pages/packages/Sikkim_Darjeeling/NorthSikkim_Silkroute_8N_9D_Page";
import NorthSikkim_7N_8D_Kolkata_Page from "../pages/packages/Sikkim_Darjeeling/NorthSikkim_7N_8D_Kolkata_Page";
import NorthSikkim_7N_8D_Ahmedabad_Page from "../pages/packages/Sikkim_Darjeeling/NorthSikkim_7N_8D_Ahmedabad_Page";
import NorthSikkim_7N_8D_Bangalore_Page from "../pages/packages/Sikkim_Darjeeling/NorthSikkim_7N_8D_Bangalore_Page";
import NorthSikkim_7N_8D_Chennai_Page from "../pages/packages/Sikkim_Darjeeling/NorthSikkim_7N_8D_Chennai_Page";
import NorthSikkim_7N_8D_Delhi_Page from "../pages/packages/Sikkim_Darjeeling/NorthSikkim_7N_8D_Delhi_Page";
import NorthSikkim_7N_8D_Hyderabad_Page from "../pages/packages/Sikkim_Darjeeling/NorthSikkim_7N_8D_Hyderabad_Page";
import NorthSikkim_7N_8D_Jaipur_Page from "../pages/packages/Sikkim_Darjeeling/NorthSikkim_7N_8D_Jaipur_Page";
import NorthSikkim_7N_8D_Kochi_Page from "../pages/packages/Sikkim_Darjeeling/NorthSikkim_7N_8D_Kochi_Page";
import NorthSikkim_7N_8D_Mumbai_Page from "../pages/packages/Sikkim_Darjeeling/NorthSikkim_7N_8D_Mumbai_Page";
import NorthSikkim_7N_8D_Nagpur_Page from "../pages/packages/Sikkim_Darjeeling/NorthSikkim_7N_8D_Nagpur_Page";
import NorthSikkim_7N_8D_Pune_Page from "../pages/packages/Sikkim_Darjeeling/NorthSikkim_7N_8D_Pune_Page";
import NorthSikkim_7N_8D_Surat_Page from "../pages/packages/Sikkim_Darjeeling/NorthSikkim_7N_8D_Surat_Page";
import NorthSikkim_7N_8D_Bhopal_Page from "../pages/packages/Sikkim_Darjeeling/NorthSikkim_7N_8D_Bhopal_Page";
import NorthSikkim_7N_8D_Indore_Page from "../pages/packages/Sikkim_Darjeeling/NorthSikkim_7N_8D_Indore_Page";
//sikkim 9N 10D URL------------------------------
import Sikkim_Tour_9N_10D_ahmedabad_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Tour_9N_10D_ahmedabad_Page";
import Sikkim_Tour_9N_10D_bagdogra_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Tour_9N_10D_bagdogra_Page";
import Sikkim_Tour_9N_10D_bangalore_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Tour_9N_10D_bangalore_Page";
import Sikkim_Tour_9N_10D_bhopal_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Tour_9N_10D_bhopal_Page";
import Sikkim_Tour_9N_10D_bhubaneswar_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Tour_9N_10D_bhubaneswar_Page";
import Sikkim_Tour_9N_10D_chandigarh_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Tour_9N_10D_chandigarh_Page";
import Sikkim_Tour_9N_10D_chennai_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Tour_9N_10D_chennai_Page";
import Sikkim_Tour_9N_10D_delhi_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Tour_9N_10D_delhi_Page";
import Sikkim_Tour_9N_10D_goa_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Tour_9N_10D_goa_Page";
import Sikkim_Tour_9N_10D_hyderabad_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Tour_9N_10D_hyderabad_Page";
import Sikkim_Tour_9N_10D_indore_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Tour_9N_10D_indore_Page";
import Sikkim_Tour_9N_10D_jaipur_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Tour_9N_10D_jaipur_Page";
import Sikkim_Tour_9N_10D_kanpur_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Tour_9N_10D_kanpur_Page";
import Sikkim_Tour_9N_10D_kochi_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Tour_9N_10D_kochi_Page";
import Sikkim_Tour_9N_10D_kolkata_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Tour_9N_10D_kolkata_Page";
import Sikkim_Tour_9N_10D_lucknow_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Tour_9N_10D_lucknow_Page";
import Sikkim_Tour_9N_10D_nagpur_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Tour_9N_10D_nagpur_Page";
import Sikkim_Tour_9N_10D_nashik_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Tour_9N_10D_nashik_Page";
import Sikkim_Tour_9N_10D_patna_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Tour_9N_10D_patna_Page";
import Sikkim_Tour_9N_10D_pondicherry_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Tour_9N_10D_pondicherry_Page";
import Sikkim_Tour_9N_10D_pune_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Tour_9N_10D_pune_Page";
import Sikkim_Tour_9N_10D_raipur_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Tour_9N_10D_raipur_Page";
import Sikkim_Tour_9N_10D_ranchi_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Tour_9N_10D_ranchi_Page";
import Sikkim_Tour_9N_10D_surat_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Tour_9N_10D_surat_Page";
import Sikkim_Tour_9N_10D_vizag_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Tour_9N_10D_vizag_Page";
import Sikkim_Tour_9N_10D_mumbai_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Tour_9N_10D_mumbai_Page";
import Sikkim_Gangtok_Tour_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Gangtok_Tour_Page";
import Sikkim_Gangtok_Kolkata_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Gangtok_Kolkata_Page";
import Sikkim_Gangtok_Chennai_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Gangtok_Chennai_Page";
import Sikkim_Gangtok_Mumbai_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Gangtok_Mumbai_Page";
import Sikkim_Gangtok_Hyderabad_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Gangtok_Hyderabad_Page";
import Sikkim_Gangtok_Kochi_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Gangtok_Kochi_Page";
import Sikkim_Gangtok_Pune_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Gangtok_Pune_Page";
import Sikkim_Gangtok_Surat_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Gangtok_Surat_Page";
import Sikkim_Gangtok_Nagpur_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Gangtok_Nagpur_Page";
import Sikkim_Gangtok_Jaipur_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Gangtok_Jaipur_Page";
import Sikkim_Gangtok_Delhi_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Gangtok_Delhi_Page";
import Sikkim_Gangtok_Ahmedabad_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Gangtok_Ahmedabad_Page";
import Sikkim_Gangtok_Bangalore_Page from "../pages/packages/Sikkim_Darjeeling/Sikkim_Gangtok_Bangalore_Page";

//Silkroute URL------------------------------
import SilkrouteTourAhmedabadPage from "../pages/packages/Sikkim_Darjeeling/SilkrouteTourAhmedabadPage";
import SilkrouteTourBangalorePage from "../pages/packages/Sikkim_Darjeeling/SilkrouteTourBangalorePage";
import SilkrouteTourChennaiPage from "../pages/packages/Sikkim_Darjeeling/SilkrouteTourChennaiPage";
import SilkrouteTourDelhiPage from "../pages/packages/Sikkim_Darjeeling/SilkrouteTourDelhiPage";
import SilkrouteTourHyderabadPage from "../pages/packages/Sikkim_Darjeeling/SilkrouteTourHyderabadPage";
import SilkrouteTourKochiPage from "../pages/packages/Sikkim_Darjeeling/SilkrouteTourKochiPage";
import SilkrouteTourMumbaiPage from "../pages/packages/Sikkim_Darjeeling/SilkrouteTourMumbaiPage";
import SilkrouteTourNagpurPage from "../pages/packages/Sikkim_Darjeeling/SilkrouteTourNagpurPage";
import SilkrouteTourPunePage from "../pages/packages/Sikkim_Darjeeling/SilkrouteTourPunePage";
import SilkrouteTourSuratPage from "../pages/packages/Sikkim_Darjeeling/SilkrouteTourSuratPage";

import Silkroute_TourKolkataPage from "../pages/packages/Sikkim_Darjeeling/Silkroute_TourKolkataPage";
import Silkroute_TourKolkata_7N_8DPage from "../pages/packages/Sikkim_Darjeeling/Silkroute_TourKolkata_7N_8DPage";
import Silkroute_TourKolkata_6N_7DPage from "../pages/packages/Sikkim_Darjeeling/Silkroute_TourKolkata_6N_7DPage";
import Silkroute_TourKolkata_4N_5DPage from "../pages/packages/Sikkim_Darjeeling/Silkroute_TourKolkata_4N_5DPage";
import Silkroute_TourKolkata_3N_4DPage from "../pages/packages/Sikkim_Darjeeling/Silkroute_TourKolkata_3N_4DPage";
import Silkroute_TourKolkata_2N_3DPage from "../pages/packages/Sikkim_Darjeeling/Silkroute_TourKolkata_2N_3DPage";
import Silkroute_PackageTour_from_NJP_StationPage from "../pages/packages/Sikkim_Darjeeling/Silkroute_PackageTour_from_NJP_StationPage";
import Silkroute_PackageTour_from_bagdogra_airportPage from "../pages/packages/Sikkim_Darjeeling/Silkroute_PackageTour_from_bagdogra_airportPage";
import Silkroute_east_sikkim_Package_Tour_from_NJP_Siliguri_BagdograPage from "../pages/packages/Sikkim_Darjeeling/Silkroute_east_sikkim_Package_Tour_from_NJP_Siliguri_BagdograPage";
//Andaman
import Andaman_6N_7D_Page from "../pages/packages/Andaman/Andaman_6N_7D_Page";
import Andaman_7N_8D_Package_Tour_Kolkata_Page from "../pages/packages/Andaman/Andaman_7N_8D_Package_Tour_Kolkata_Page";
import Andaman_5N_6D_Honeymoon_Tour_Page from "../pages/packages/Andaman/Andaman_5N_6D_Honeymoon_Tour_Page";

//ladakh URL

import Ladakh_6N_7D_Page from "../pages/packages/Ladakh/Ladakh_6N_7D_Page";
import Leh_Ladakh_Kargil_8N_9D_Page from "../pages/packages/Ladakh/Leh_Ladakh_Kargil_8N_9D_Page";
import Leh_Ladakh_Turtuk_Page from "../pages/packages/Ladakh/Leh_Ladakh_Turtuk_Page";
import Ladakh_7N_8D_Mumbai_Page from "../pages/packages/Ladakh/Ladakh_7N_8D_Mumbai_Page";

// kashmir URL
import Kashmir_6N_7D_Page from "../pages/packages/Kashmir/Kashmir_6N_7D_Page";
import Kashmir_8N_9D_Doodhpathri_Yusmarg_Page from "../pages/packages/Kashmir/Kashmir_8N_9D_Doodhpathri_Yusmarg_Page";
import Kashmir_7N_8D_Gurez_valley_Page from "../pages/packages/Kashmir/Kashmir_7N_8D_Gurez_valley_Page";
import Kashmir_Leh_Ladakh_Tour_Page from "../pages/packages/Kashmir/Kashmir_Leh_Ladakh_Tour_Page";
import Kashmir_7N_8D_Sinthan_Top_Page from "../pages/packages/Kashmir/Kashmir_7N_8D_Sinthan_Top_Page";
import Kashmir_7N_8D_Vaishno_Devi_Page from "../pages/packages/Kashmir/Kashmir_7N_8D_Vaishno_Devi_Page";
import Kashmir_7N_8D_Tulip_Page from "../pages/packages/Kashmir/Kashmir_7N_8D_Tulip_Page";
import Kashmir_7N_8D_Tour_From_Kolkata_Page from "../pages/packages/Kashmir/Kashmir_7N_8D_Tour_From_Kolkata_Page";
import Kashmir_7N_8D_Tour_From_Surat_Page from "../pages/packages/Kashmir/Kashmir_7N_8D_Tour_From_Surat_Page";
import Kashmir_7N_8D_Tour_From_Chennai_Page from "../pages/packages/Kashmir/Kashmir_7N_8D_Tour_From_Chennai_Page";
import Kashmir_7N_8D_Tour_From_Bangalore_Page from "../pages/packages/Kashmir/Kashmir_7N_8D_Tour_From_Bangalore_Page";
import Kashmir_7N_8D_Tour_From_Pune_Page from "../pages/packages/Kashmir/Kashmir_7N_8D_Tour_From_Pune_Page";
import Kashmir_7N_8D_Tour_From_Mumbai_Page from "../pages/packages/Kashmir/Kashmir_7N_8D_Tour_From_Mumbai_Page";
import Kashmir_4N_5D_Tour_From_Delhi_Page from "../pages/packages/Kashmir/Kashmir_4N_5D_Tour_From_Delhi_Page";
import Kashmir_4N_5D_Tour_From_Ahmedabad_Page from "../pages/packages/Kashmir/Kashmir_7N_8D_Tour_From_Ahmedabad_Page";
import Kashmir_7N_8D_Family_Page from "../pages/packages/Kashmir/Kashmir_7N_8D_Family_Page";
import Kashmir_9N_10D_Vaishno_Devi_Amritsar_Page from "../pages/packages/Kashmir/Kashmir_9N_10D_Vaishno_Devi_Amritsar_Page";
import Kashmir_12N_13D_Tulip_Group_Tour_Kolkata_Page from "../pages/packages/Kashmir/Kashmir_12N_13D_Tulip_Group_Tour_Kolkata_Page";
///Thailand URL------------------------------------------------
import Thailand_8N_9D_Page from "../pages/packages/Thailand/Thailand_8N_9D_Page";
import BangkokPattaya_8N_9D_Page from "../pages/packages/Thailand/BangkokPattaya_8N_9D_Page";
//Vietnam URL
import Vietnam_7N_8D_Page from "../pages/packages/Vietnam/Vietnam_7N_8D_Page";
import Vietnam_7N_8D_Kolkata_Page from "../pages/packages/Vietnam/Vietnam_7N_8D_Kolkata_Page";
//Egypt Route--------------------------------------------------
import Egypt_8N_9D_Page from "../pages/packages/Egypt/Egypt_8N_9D_Page";
//Arunachal URL-----------------------------------------------
import ArunachalTourGuwahati_15N_16D_Page from "../pages/packages/Arunachal_Pradesh/ArunachalTourGuwahati_15N_16D_Page";
import ArunachalTourMumbai_14N_15D_Page from "../pages/packages/Arunachal_Pradesh/ArunachalTourMumbai_14N_15D_Page";
import ArunachalTourKolkata_9N_10D_Page from "../pages/packages/Arunachal_Pradesh/ArunachalTourKolkata_9N_10D_Page";
import TawangBumlaPass_7N_8D_Page from "../pages/packages/Arunachal_Pradesh/TawangBumlaPass_7N_8D_Page";
import AssamArunachalBangalore_11N_12D_Page from "../pages/packages/Arunachal_Pradesh/AssamArunachalBangalore_11N_12D_Page";
import Arunachal_10N_11D_Page from "../pages/packages/Arunachal_Pradesh/Arunachal_10N_11D_Page";
import Arunachal_11N_12D_Page from "../pages/packages/Arunachal_Pradesh/Arunachal_11N_12D_Page";
import ArunachalGroupTourGuwahati_7N_8D_Page from "../pages/packages/Arunachal_Pradesh/ArunachalGroupTourGuwahati_7N_8D_Page";
import ArunachalTourDelhi_Page from "../pages/packages/Arunachal_Pradesh/ArunachalTourDelhi_Page";
import ArunachalTourChennai_Page from "../pages/packages/Arunachal_Pradesh/ArunachalTourChennai_Page";
import ArunachalTourBangalore_Page from "../pages/packages/Arunachal_Pradesh/ArunachalTourBangalore_Page";
import ArunachalTourAmhedabad_Page from "../pages/packages/Arunachal_Pradesh/ArunachalTourAmhedabad_Page";
import ArunachalTourPune_Page from "../pages/packages/Arunachal_Pradesh/ArunachalTourPune_Page";
import ArunachalTourSurat_Page from "../pages/packages/Arunachal_Pradesh/ArunachalTourSurat_Page";
import ArunachalTourNagpur_Page from "../pages/packages/Arunachal_Pradesh/ArunachalTourNagpur_Page";
import ArunachalTourHyderabad_Page from "../pages/packages/Arunachal_Pradesh/ArunachalTourHyderabad_Page";
import ArunachalTourJaipur_Page from "../pages/packages/Arunachal_Pradesh/ArunachalTourJaipur_Page";
import ArunachalTourKochi_Page from "../pages/packages/Arunachal_Pradesh/ArunachalTourKochi_Page";
//sundarban URL-----------------------------------------------
import SundarbanTourPage_Sonarbangla from "../pages/packages/Sundarban/SundarbanTourPage_Sonarbangla";
import SundarbanTourPage_Kolkata from "../pages/packages/Sundarban/SundarbanTourPage_Kolkata";
import Sandakphu_trekking_Page from "../pages/packages/Sandakphu/Sandakphu_trekking_Page";
//Lakshadweep URL------------------------------------------------
import LakshadweepTourKochi_4N_5D_Page from "../pages/packages/Lakshadweep/LakshadweepTourKochi_4N_5D_Page";
import LakshadweepTourHoneymoon_4N_5D_Page from "../pages/packages/Lakshadweep/LakshadweepTourHoneymoon_4N_5D_Page";
import LakshadweepTourHyderabad_4N_5D_Page from "../pages/packages/Lakshadweep/LakshadweepTourHyderabad_4N_5D_Page";
import LakshadweepTourKolkata_4N_5D_Page from "../pages/packages/Lakshadweep/LakshadweepTourKolkata_4N_5D_Page";
import LakshadweepTourMumbai_4N_5D_Page from "../pages/packages/Lakshadweep/LakshadweepTourMumbai_4N_5D_Page";
import LakshadweepTourPune_4N_5D_Page from "../pages/packages/Lakshadweep/LakshadweepTourPune_4N_5D_Page";
import LakshadweepTourSurat_4N_5D_Page from "../pages/packages/Lakshadweep/LakshadweepTourSurat_4N_5D_Page";
import LakshadweepTourGoa_4N_5D_Page from "../pages/packages/Lakshadweep/LakshadweepTourGoa_4N_5D_Page";
import LakshadweepTourFamily_4N_5D_Page from "../pages/packages/Lakshadweep/LakshadweepTourFamily_4N_5D_Page";
import LakshadweepTourAhmedabad_4N_5D_Page from "../pages/packages/Lakshadweep/LakshadweepTourAhmedabad_4N_5D_Page";
import LakshadweepTourChennai_4N_5D_Page from "../pages/packages/Lakshadweep/LakshadweepTourChennai_4N_5D_Page";
import LakshadweepTourDelhi_4N_5D_Page from "../pages/packages/Lakshadweep/LakshadweepTourDelhi_4N_5D_Page";
import LakshadweepTourBangalore_4N_5D_Page from "../pages/packages/Lakshadweep/LakshadweepTourBangalore_4N_5D_Page";
//---------------Sandakphu URL-------------------------------
import Sandakphu_land_rover_Page from "../pages/packages/Sandakphu/Sandakphu_land_rover_Page";
import Sandakphu_land_rover_Kolkata_Page from "../pages/packages/Sandakphu/Sandakphu_land_rover_Kolkata_Page";
import Sandakphu_land_rover_Bangalore_Page from "../pages/packages/Sandakphu/Sandakphu_land_rover_Bangalore_Page";
import Sandakphu_land_rover_Mumbai_Page from "../pages/packages/Sandakphu/Sandakphu_land_rover_Mumbai_Page";
import Sandakphu_land_rover_Delhi_Page from "../pages/packages/Sandakphu/Sandakphu_land_rover_Delhi_Page";
import Sandakphu_land_rover_Pune_Page from "../pages/packages/Sandakphu/Sandakphu_land_rover_Pune_Page";
import Sandakphu_land_rover_Chennai_Page from "../pages/packages/Sandakphu/Sandakphu_land_rover_Chennai_Page";
import SandakphuPujaSpecialLandRoverPage from "../pages/packages/Sandakphu/SandakphuPujaSpecialLandRoverPage";
//------------------Srilanka URL-----------------------------
import SrilankaKolkataPage from "../pages/packages/Srilanka/SrilankaKolkataPage";
//----------------------Dubai URL---------------------------------
import DubaiKolkataPage from "../pages/packages/Dubai/DubaiKolkataPage";


class AppRoute extends Component {
  render() {
    return (
      <Fragment>
        <Switch>
          <Route
            exact
            path="/"
            render={props => <HomePage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/home"
            render={props => <HomePage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/contact"
            render={props => <ContactPage {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/blog"
            render={props => <BlogPage {...props} key={Date.now()} />}
          />
              <Route
            exact
            path="/gallery"
            render={props => <GalleryPage {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/bhutan-inside"
            render={props => <BhutanGalleryInsidePage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/purchase"
            render={props => <PurchasePage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/cancellation-policy"
            render={props => <PolicyPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/refund"
            render={props => <RefundPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/visa-consutancy-services"
            render={props => <VisaService {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/about"
            render={props => <AboutPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/adventure-tour-ladakh-to-sikkim"
            render={props => <AdventureTourLadakhToSikkimPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-blog"
            render={props => <Bhutan_blog_Page {...props} key={Date.now()} />}
          />
          {/* Sandakphu Start */}
          <Route
            exact
            path="/sandakphu-puja-special-group-package-tour"
            render={props => <SandakphuPujaSpecialLandRoverPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sandakphu-land-rover-package-tour-from-kolkata"
            render={props => <Sandakphu_land_rover_Kolkata_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sandakphu-land-rover-package-tour-from-bangalore"
            render={props => <Sandakphu_land_rover_Bangalore_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sandakphu-land-rover-package-tour-from-chennai"
            render={props => <Sandakphu_land_rover_Chennai_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/sandakphu-land-rover-package-tour-from-delhi"
            render={props => <Sandakphu_land_rover_Delhi_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sandakphu-land-rover-package-tour-from-mumbai"
            render={props => <Sandakphu_land_rover_Mumbai_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sandakphu-land-rover-package-tour-from-pune"
            render={props => <Sandakphu_land_rover_Pune_Page {...props} key={Date.now()} />}
          />
          {/* Lakshadweep Start */}
          <Route
            exact
            path="/lakshadweep-package-tour-from-surat"
            render={props => <LakshadweepTourSurat_4N_5D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/lakshadweep-package-tour-from-pune"
            render={props => <LakshadweepTourPune_4N_5D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/lakshadweep-package-tour-from-mumbai"
            render={props => <LakshadweepTourMumbai_4N_5D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/lakshadweep-package-tour-from-kolkata"
            render={props => <LakshadweepTourKolkata_4N_5D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/lakshadweep-package-tour-from-goa"
            render={props => <LakshadweepTourGoa_4N_5D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/lakshadweep-package-tour-from-goa"
            render={props => <LakshadweepTourGoa_4N_5D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/lakshadweep-family-package-tour"
            render={props => <LakshadweepTourFamily_4N_5D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/lakshadweep-package-tour-from-delhi"
            render={props => <LakshadweepTourDelhi_4N_5D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/lakshadweep-package-tour-from-chennai"
            render={props => <LakshadweepTourChennai_4N_5D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/lakshadweep-package-tour-from-bangalore"
            render={props => <LakshadweepTourBangalore_4N_5D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/lakshadweep-package-tour-from-ahmedabad"
            render={props => <LakshadweepTourAhmedabad_4N_5D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/lakshadweep-package-tour-from-hyderabad"
            render={props => <LakshadweepTourHyderabad_4N_5D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/lakshadweep-honeymoon-package-tour-by-flight"
            render={props => <LakshadweepTourHoneymoon_4N_5D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/lakshadweep-package-tour-from-kochi-by-flight"
            render={props => <LakshadweepTourKochi_4N_5D_Page {...props} key={Date.now()} />}
          />
          {/* Bhutan start */}
          <Route
            exact
            path="/bhutan-womens-special-package-tour"
            render={props => <Bhutan_woman_spl_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-10-nights-11-days-package-tour-from-kolkata"
            render={props => <Bhutan_Kolkata_ex_10N_11D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-9-nights-10-days-package-tour-from-kolkata"
            render={props => <Bhutan_Kolkata_ex_9N_10D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-8-nights-9-days-package-tour-from-kolkata"
            render={props => <Bhutan_Kolkata_ex_8N_9D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-7-nights-8-days-package-tour-from-kolkata"
            render={props => <Bhutan_Kolkata_ex_7N_8D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-6-nights-7-days-package-tour-from-kolkata"
            render={props => <Bhutan_Kolkata_ex_6N_7D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-5-nights-6-days-package-tour-from-kolkata"
            render={props => <Bhutan_Kolkata_ex_5N_6D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-4-nights-5-days-package-tour-from-kolkata"
            render={props => <Bhutan_Kolkata_ex_4N_5D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-10-nights-11-days-package-tour-from-delhi"
            render={props => <Bhutan_Delhi_ex_10N_11D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-9-nights-10-days-package-tour-from-delhi"
            render={props => <Bhutan_Delhi_ex_9N_10D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-8-nights-9-days-package-tour-from-delhi"
            render={props => <Bhutan_Delhi_ex_8N_9D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-7-nights-8-days-package-tour-from-delhi"
            render={props => <Bhutan_Delhi_ex_7N_8D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-6-nights-7-days-package-tour-from-delhi"
            render={props => <Bhutan_Delhi_ex_6N_7D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-5-nights-6-days-package-tour-from-delhi"
            render={props => <Bhutan_Delhi_ex_5N_6D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-4-nights-5-days-package-tour-from-delhi"
            render={props => <Bhutan_Delhi_ex_4N_5D_Page {...props} key={Date.now()} />}
          />
          {/* ------------------------ */}
          <Route
            exact
            path="/bhutan-package-tour-from-thiruvananthapuram"
            render={props => <BagdograToThiruvananthapuramPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-package-tour-from-chandigarh"
            render={props => <BagdograToChandigarhPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-package-tour-from-ranchi"
            render={props => <BagdograToRanchiPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-package-tour-from-rajkot"
            render={props => <BagdograToRajkotPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-package-tour-from-patna"
            render={props => <BagdograToPatnaPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-package-tour-from-lucknow"
            render={props => <BagdograToLucknowPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-package-tour-from-kochi"
            render={props => <BagdograToKochiPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-package-tour-from-jamnagar"
            render={props => <BagdograToJamnagarPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-package-tour-from-jaipur"
            render={props => <BagdograToJaipurPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-package-tour-from-coimbatore"
            render={props => <BagdograToCoimbatorePage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-package-tour-from-bhubaneswar"
            render={props => <BagdograToBhubaneswarPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-package-tour-from-goa"
            render={props => <BagdograToGoaPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-package-tour-from-mysore"
            render={props => <BagdograToMysorePage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-4nights-5days-package-tour"
            render={props => <Bhutan_4N_5D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-5nights-6days-package-tour"
            render={props => <Bhutan_5N_6D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-6nights-7days-package-tour"
            render={props => <Bhutan_6N_7D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-7nights-8days-package-tour"
            render={props => <Bhutan_7N_8D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-8nights-9days-package-tour"
            render={props => <Bhutan_8N_9D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-9nights-10days-package-tour"
            render={props => <Bhutan_9N_10D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-10nights-11days-package-tour"
            render={props => <Bhutan_10N_11D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/eastern-bhutan-package-tour-with-trashigang-trongsa-bumthang-mongar"
            render={props => <EasternBhutanPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-package-tour-from-bhopal"
            render={props => <Bhutan_Bhopal_6N_7D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-package-tour-from-nashik"
            render={props => <Bhutan_Nashik_6N_7D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-package-tour-from-nagpur"
            render={props => <Bhutan_Nagpur_6N_7D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-group-tour-packages-from-bagdogra-airport"
            render={props => <Bagdogra_7N_8D_Group_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-DMC-b2b-packages-for-Bhutan-tour-from-bagdogra-airport-via-phuentsholing"
            render={props => <Bhutan_B2B_7N_8D_Bagdogra_Airport_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-package-tour-from-bangalore-with-flight-from-kolkata-airport-guwahati-airport"
            render={props => <BangaloreToBhutanviaKolkataAirportPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-tour-package-from-jaigaon"
            render={props => <Bhutan_TourJaigaonPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-package-tour-from-njp-station-siliguri-bus-stand"
            render={props => <Bhutan_TourNjpSiliguriPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-package-tour-from-phuentsholing"
            render={props => <Bhutan_TourPhuentsholingPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-package-tour-from-hasimara-new-alipurduar"
            render={props => <Bhutan_TourHasimaraNoqPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-hotel-six-senses-package-tour-with-direct-flight-from-india"
            render={props => <Bhutan_TourSixsenseDirectFlightIndiaPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-luxury-package-tour-with-six-senses-hotel"
            render={props => <Bhutan_TourSixsenseHotelPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-package-tour-from-guwahati-airport"
            render={props => <Bhutan_TourGuwahatiPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-b2b-package-tour-operator-in-india-best-bhutan-dmc"
            render={props => <Bhutan_B2B_7N_8D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-tour-package"
            render={props => <BhutanTourPackagePage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/4N-5D-FIFO-package"
            render={props => <FIFO_4N_5D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/5N-6D-FIFO-package"
            render={props => <FIFO_5N_6D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/6N-7D-FIFO-package"
            render={props => <FIFO_6N_7D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/mumbai-special-chartered-flight"
            render={props => <FIFO_7N_8D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/8N-9D-FIFO-package"
            render={props => <FIFO_8N_9D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/10N-11D-FIFO-package"
            render={props => <FIFO_10N_11D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-tour-from-delhi"
            render={props => <DelhiToBhutanPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-tour-package-from-mumbai"
            render={props => <MumbaiToBhutanPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-tour-package-from-kolkata"
            render={props => <KolkataToBhutanPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-tour-package-from-chennai"
            render={props => <ChennaiToBhutanPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-tour-package-from-hyderabad"
            render={props => <HyderabadToBhutanPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-tour-package-from-ahemdabad"
            render={props => <AhemdabadToBhutanPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-tour-package-from-bangalore"
            render={props => <BangaloreToBhutanPackage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-tour-package-from-pune"
            render={props => <PuneToBhutanPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-tour-package-from-bagdogra"
            render={props => <Bagdogra_6N_7D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bhutan-tour-package-from-surat"
            render={props => <SuratToBhutanPage {...props} key={Date.now()} />}
          />
          {/* north east start */}
          <Route
            exact
            path="/north-east-india-package-tour-from-guwahati-airport"
            render={props => <NorthEastIndiaTour_10N_11D_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/north-east-package-tour-from-mumbai"
            render={props => <NorthEastMumbaiTour_10N_11D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/north-east-package-tour-from-pune"
            render={props => <NorthEastPuneTour_10N_11D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/north-east-package-tour-from-nagpur"
            render={props => <NorthEastNagpurTour_10N_11D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/north-east-package-tour-from-nashik"
            render={props => <NorthEastNashikTour_10N_11D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/north-east-package-tour-from-ahmedabad"
            render={props => <NorthEastAhmedabadTour_10N_11D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/north-east-package-tour-from-surat"
            render={props => <NorthEastSuratTour_10N_11D_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/north-east-package-tour-from-rajkot"
            render={props => <NorthEastRajkotTour_10N_11D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/north-east-package-tour-from-vadodara"
            render={props => <NorthEastVadodaraTour_10N_11D_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/north-east-package-tour-from-jaipur"
            render={props => <NorthEastJaipurTour_10N_11D_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/north-east-package-tour-from-chandigarh"
            render={props => <NorthEastChandigarhTour_10N_11D_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/north-east-package-tour-from-delhi"
            render={props => <NorthEastDelhiTour_10N_11D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/north-east-package-tour-from-patna"
            render={props => <NorthEastPatnaTour_10N_11D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/north-east-package-tour-from-ranchi"
            render={props => <NorthEastRanchiTour_10N_11D_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/north-east-package-tour-from-kolkata"
            render={props => <NorthEastKolkataTour_10N_11D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/north-east-package-tour-from-bhubaneswar"
            render={props => <NorthEastBhubaneswarTour_10N_11D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/north-east-package-tour-from-hyderabad"
            render={props => <NorthEastHyderabadTour_10N_11D_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/north-east-package-tour-from-bangalore"
            render={props => <NorthEastBangaloreTour_10N_11D_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/north-east-package-tour-from-chennai"
            render={props => <NorthEastChennaiTour_10N_11D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/north-east-package-tour-from-kochi"
            render={props => <NorthEastKochiTour_10N_11D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/north-east-package-tour-from-goa"
            render={props => <NorthEastGoaTour_10N_11D_Page {...props} key={Date.now()} />}
          />
          {/* Meghalaya Route */}
          <Route
            exact
            path="/kaziranga-package-tour-from-guwahati-with-elephant-safari-jeep-safari"
            render={props => <KazirangaTourWithElephantSafari_7N_8D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/meghalaya-tour-package"
            render={props => <MeghalayaTourPackagePage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/Assam-Meghalaya-5N-6D-Tour-Itinerary"
            render={props => <Meghalaya_5N_6D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/Meghalaya-Assam-Tour-Packages-6N-7D"
            render={props => <Meghalaya_6N_7D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/shillong-meghalaya-package-tour-from-guwahati"
            render={props => <ShillongMeghalayaTour_6N_7D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/kaziranga-shillong-cherrapunjee-package-tour-from-guwahati"
            render={props => <KazirangaShillongMeghalayaTour_7N_8D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/Meghalaya-Kaziranga-Tour-Packages-7N-8D"
            render={props => <Meghalaya_7N_8D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/meghalaya-arunachal-pradesh-package-tour-from-guwahati"
            render={props => <MeghalayaArunachalTour_12N_13D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/meghalaya-shillong-cherrapunji-package-tour-from-guwahati-with-garo-hills-tura-wari-chora"
            render={props => <MeghalayaShillongCherrapunjeeTour_7N_8D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/meghalaya-package-tour-with-wari-chora-tura-south-garo-hills-mawsynram-jowai-mawlynnong-dawki"
            render={props => <Meghalaya_WariChora_Tura_7N_8D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/assam-meghalaya-arunachal-pradesh-package-tour-from-guwahati"
            render={props => <Assam_Meghalaya_Arunachal_19N_20D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/kaziranga-shillong-cherrapunjee-group-tour-packages-from-guwahati"
            render={props => <KazirangaShillongCherrapunjeeGroupTour_8N_9D_Page {...props} key={Date.now()} />}
          />
          {/* North East 2nd lot sukantada new page end */}
          <Route
            exact
            path="/arunachal-pradesh-package-tour-from-kochi"
            render={props => <ArunachalTourKochi_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/arunachal-pradesh-package-tour-from-jaipur"
            render={props => <ArunachalTourJaipur_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/arunachal-pradesh-package-tour-from-hyderabad"
            render={props => <ArunachalTourHyderabad_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/arunachal-pradesh-package-tour-from-nagpur"
            render={props => <ArunachalTourNagpur_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/arunachal-pradesh-package-tour-from-surat"
            render={props => <ArunachalTourSurat_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/arunachal-pradesh-package-tour-from-pune"
            render={props => <ArunachalTourPune_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/arunachal-pradesh-package-tour-from-ahmedabad"
            render={props => <ArunachalTourAmhedabad_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/arunachal-pradesh-package-tour-from-bangalore"
            render={props => <ArunachalTourBangalore_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/arunachal-pradesh-package-tour-from-chennai"
            render={props => <ArunachalTourChennai_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/arunachal-pradesh-package-tour-from-delhi"
            render={props => <ArunachalTourDelhi_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/arunachal-pradesh-group-tour-packages-from-guwahati-airport-assam"
            render={props => <ArunachalGroupTourGuwahati_7N_8D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/arunachal-pradesh-package-tour-from-guwahati"
            render={props => <ArunachalTourGuwahati_15N_16D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/arunachal-pradesh-package-tour-from-mumbai"
            render={props => <ArunachalTourMumbai_14N_15D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/arunachal-pradesh-package-tour-from-kolkata"
            render={props => <ArunachalTourKolkata_9N_10D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/Arunachal-Pradesh-Tawang-Tour-Package-10N-11D"
            render={props => <Arunachal_10N_11D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/Arunachal-Pradesh-11N-12D-Tour-Package"
            render={props => <Arunachal_11N_12D_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/tawang-bumla-pass-package-tour-from-guwahati"
            render={props => <TawangBumlaPass_7N_8D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/assam-arunachal-pradesh-package-tour-from-bangalore"
            render={props => <AssamArunachalBangalore_11N_12D_Page {...props} key={Date.now()} />}
          />
          
          {/* silkroute start */}
          <Route
            exact
            path="/east-sikkim-silk-route-package-tour-from-siliguri-njp-bagdogra"
            render={props => <Silkroute_east_sikkim_Package_Tour_from_NJP_Siliguri_BagdograPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/silk-route-package-tour-from-bagdogra-airport"
            render={props => <Silkroute_PackageTour_from_bagdogra_airportPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/silk-route-package-tour-from-njp-station"
            render={props => <Silkroute_PackageTour_from_NJP_StationPage {...props} key={Date.now()} />}
          />
          
           <Route
            exact
            path="/silk-route-package-tour-2-night-3-days"
            render={props => <Silkroute_TourKolkata_2N_3DPage {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/silk-route-package-tour-3-night-4-days"
            render={props => <Silkroute_TourKolkata_3N_4DPage {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/silk-route-package-tour-4-nights-5-days"
            render={props => <Silkroute_TourKolkata_4N_5DPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/silk-route-package-tour-6-nights-7-days"
            render={props => <Silkroute_TourKolkata_6N_7DPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/silk-route-package-tour-7-nights-8-days"
            render={props => <Silkroute_TourKolkata_7N_8DPage {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/silk-route-package-tour-from-kolkata"
            render={props => <Silkroute_TourKolkataPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/silk-route-package-tour-from-ahmedabad"
            render={props => <SilkrouteTourAhmedabadPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/silk-route-package-tour-from-bangalore"
            render={props => <SilkrouteTourBangalorePage {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/silk-route-package-tour-from-chennai"
            render={props => <SilkrouteTourChennaiPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/silk-route-package-tour-from-delhi"
            render={props => <SilkrouteTourDelhiPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/silk-route-package-tour-from-hyderabad"
            render={props => <SilkrouteTourHyderabadPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/silk-route-package-tour-from-kochi"
            render={props => <SilkrouteTourKochiPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/silk-route-package-tour-from-mumbai"
            render={props => <SilkrouteTourMumbaiPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/silk-route-package-tour-from-nagpur"
            render={props => <SilkrouteTourNagpurPage {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/silk-route-package-tour-from-pune"
            render={props => <SilkrouteTourPunePage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/silk-route-package-tour-from-surat"
            render={props => <SilkrouteTourSuratPage {...props} key={Date.now()} />}
          />
           {/* silkroute end */}

           {/* sikkim start */}
          
           <Route
            exact
            path="/sikkim-package-tour-from-ahmedabad"
            render={props => <Sikkim_Tour_9N_10D_ahmedabad_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/sikkim-package-tour-from-bangalore"
            render={props => <Sikkim_Tour_9N_10D_bangalore_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/sikkim-package-tour-from-bhopal"
            render={props => <Sikkim_Tour_9N_10D_bhopal_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/sikkim-package-tour-from-bhubaneswar"
            render={props => <Sikkim_Tour_9N_10D_bhubaneswar_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/sikkim-package-tour-from-chandigarh"
            render={props => <Sikkim_Tour_9N_10D_chandigarh_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/sikkim-package-tour-from-chennai"
            render={props => <Sikkim_Tour_9N_10D_chennai_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sikkim-package-tour-from-delhi"
            render={props => <Sikkim_Tour_9N_10D_delhi_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sikkim-package-tour-from-goa"
            render={props => <Sikkim_Tour_9N_10D_goa_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/sikkim-package-tour-from-hyderabad"
            render={props => <Sikkim_Tour_9N_10D_hyderabad_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/sikkim-package-tour-from-indore"
            render={props => <Sikkim_Tour_9N_10D_indore_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sikkim-package-tour-from-jaipur"
            render={props => <Sikkim_Tour_9N_10D_jaipur_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/sikkim-package-tour-from-kanpur"
            render={props => <Sikkim_Tour_9N_10D_kanpur_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/sikkim-package-tour-from-kochi"
            render={props => <Sikkim_Tour_9N_10D_kochi_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sikkim-package-tour-from-kolkata"
            render={props => <Sikkim_Tour_9N_10D_kolkata_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sikkim-package-tour-from-lucknow"
            render={props => <Sikkim_Tour_9N_10D_lucknow_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sikkim-package-tour-from-nagpur"
            render={props => <Sikkim_Tour_9N_10D_nagpur_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sikkim-package-tour-from-nashik"
            render={props => <Sikkim_Tour_9N_10D_nashik_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sikkim-package-tour-from-patna"
            render={props => <Sikkim_Tour_9N_10D_patna_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/sikkim-package-tour-from-pondicherry"
            render={props => <Sikkim_Tour_9N_10D_pondicherry_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sikkim-package-tour-from-pune"
            render={props => <Sikkim_Tour_9N_10D_pune_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/sikkim-package-tour-from-raipur"
            render={props => <Sikkim_Tour_9N_10D_raipur_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sikkim-package-tour-from-ranchi"
            render={props => <Sikkim_Tour_9N_10D_ranchi_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/sikkim-package-tour-from-surat"
            render={props => <Sikkim_Tour_9N_10D_surat_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/sikkim-package-tour-from-vizag"
            render={props => <Sikkim_Tour_9N_10D_vizag_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/sikkim-package-tour-from-mumbai"
            render={props => <Sikkim_Tour_9N_10D_mumbai_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/sikkim-gangtok-package-tour"
            render={props => <Sikkim_Gangtok_Tour_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/sikkim-gangtok-package-tour-from-kolkata"
            render={props => <Sikkim_Gangtok_Kolkata_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/sikkim-gangtok-package-tour-from-chennai"
            render={props => <Sikkim_Gangtok_Chennai_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/sikkim-gangtok-package-tour-from-mumbai"
            render={props => <Sikkim_Gangtok_Mumbai_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sikkim-gangtok-package-tour-from-hyderabad"
            render={props => <Sikkim_Gangtok_Hyderabad_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sikkim-gangtok-package-tour-from-kochi"
            render={props => <Sikkim_Gangtok_Kochi_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sikkim-gangtok-package-tour-from-pune"
            render={props => <Sikkim_Gangtok_Pune_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sikkim-gangtok-package-tour-from-surat"
            render={props => <Sikkim_Gangtok_Surat_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sikkim-gangtok-package-tour-from-nagpur"
            render={props => <Sikkim_Gangtok_Nagpur_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sikkim-gangtok-package-tour-from-jaipur"
            render={props => <Sikkim_Gangtok_Jaipur_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sikkim-gangtok-package-tour-from-delhi"
            render={props => <Sikkim_Gangtok_Delhi_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sikkim-gangtok-package-tour-from-ahmedabad"
            render={props => <Sikkim_Gangtok_Ahmedabad_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sikkim-gangtok-package-tour-from-bangalore"
            render={props => <Sikkim_Gangtok_Bangalore_Page {...props} key={Date.now()} />}
          />
          {/* ...........END SIKKIM.................................... */}
           <Route
            exact
            path="/north-sikkim-package-tour-from-indore"
            render={props => <NorthSikkim_7N_8D_Indore_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/north-sikkim-package-tour-from-bhopal"
            render={props => <NorthSikkim_7N_8D_Bhopal_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/north-sikkim-package-tour-from-Surat"
            render={props => <NorthSikkim_7N_8D_Surat_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/north-sikkim-package-tour-from-Pune"
            render={props => <NorthSikkim_7N_8D_Pune_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/north-sikkim-package-tour-from-Nagpur"
            render={props => <NorthSikkim_7N_8D_Nagpur_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/north-sikkim-package-tour-from-Mumbai"
            render={props => <NorthSikkim_7N_8D_Mumbai_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/north-sikkim-package-tour-from-kochi"
            render={props => <NorthSikkim_7N_8D_Kochi_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/north-sikkim-package-tour-from-jaipur"
            render={props => <NorthSikkim_7N_8D_Jaipur_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/north-sikkim-package-tour-from-hyderabad"
            render={props => <NorthSikkim_7N_8D_Hyderabad_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/north-sikkim-package-tour-from-delhi"
            render={props => <NorthSikkim_7N_8D_Delhi_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/north-sikkim-package-tour-from-chennai"
            render={props => <NorthSikkim_7N_8D_Chennai_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/north-sikkim-package-tour-from-bangalore"
            render={props => <NorthSikkim_7N_8D_Bangalore_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/north-sikkim-package-tour-from-ahmedabad"
            render={props => <NorthSikkim_7N_8D_Ahmedabad_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/north-sikkim-package-tour-from-kolkata"
            render={props => <NorthSikkim_7N_8D_Kolkata_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/silk-route-package-tour-with-gangtok-north-sikkim-from-bagdogra-airport-njp-station"
            render={props => <NorthSikkim_Silkroute_8N_9D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/Sikkim-Gangtok-Darjeeling-Tour-Package"
            render={props => <Sikkim_Darjeeling_4N_5D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sikkim-tour-packages-from-bagdogra-njp-siliguri"
            render={props => <Sikkim_Tour_9N_10D_bagdogra_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sikkim-tour-package"
            render={props => <Sikkim_5N_6D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/North-Sikkim-2N-3D-Package-Tour-from-Gangtok-to-Gangtok-2-Night-3-Days-North-sikkim-Tour-Package"
            render={props => <NorthSikkim_2N_3D_Gangtok_Page {...props} key={Date.now()} />}
          />
          

          {/* Andaman Package Tour */}
          <Route
            exact
            path="/Andaman-6N-7D-Tour-Package"
            render={props => <Andaman_6N_7D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/andaman-package-tour-from-kolkata"
            render={props => <Andaman_7N_8D_Package_Tour_Kolkata_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/andaman-honeymoon-package-tour-from-kolkata"
            render={props => <Andaman_5N_6D_Honeymoon_Tour_Page {...props} key={Date.now()} />}
          />
          {/* kashmir package tour */}
          <Route
            exact
            path="/tulip-festival-special-kashmir-group-tour-packages-from-kolkata-by-train"
            render={props => <Kashmir_12N_13D_Tulip_Group_Tour_Kolkata_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/Kashmir-Tour-Package-from-Srinagar-Airport"
            render={props => <Kashmir_6N_7D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/kashmir-offbeat-package-tour-with-baisaran-valley-doodhpathri-yusmarg"
            render={props => <Kashmir_8N_9D_Doodhpathri_Yusmarg_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/kashmir-offbeat-package-tour-with-gurez-valley"
            render={props => <Kashmir_7N_8D_Gurez_valley_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/kashmir-offbeat-package-tour-with-sinthan-top-aru-valley-betab-valley-chandanbari-pahalgam-sonmarg"
            render={props => <Kashmir_7N_8D_Sinthan_Top_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/kashmir-package-tour-with-vaishno-devi-katra-pahalgam-gulmarg-srinagar"
            render={props => <Kashmir_7N_8D_Vaishno_Devi_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/kashmir-tulip-garden-festival-package-tour"
            render={props => <Kashmir_7N_8D_Tulip_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/kashmir-package-tour-from-kolkata-with-srinagar-gulmarg-pahalgam-sonmarg"
            render={props => <Kashmir_7N_8D_Tour_From_Kolkata_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/kashmir-package-tour-from-surat"
            render={props => <Kashmir_7N_8D_Tour_From_Surat_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/kashmir-package-tour-from-chennai"
            render={props => <Kashmir_7N_8D_Tour_From_Chennai_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/kashmir-package-tour-from-bangalore"
            render={props => <Kashmir_7N_8D_Tour_From_Bangalore_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/kashmir-package-tour-from-pune"
            render={props => <Kashmir_7N_8D_Tour_From_Pune_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/kashmir-package-tour-from-mumbai"
            render={props => <Kashmir_7N_8D_Tour_From_Mumbai_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/kashmir-package-tour-from-delhi"
            render={props => <Kashmir_4N_5D_Tour_From_Delhi_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/kashmir-package-tour-from-ahmedabad"
            render={props => <Kashmir_4N_5D_Tour_From_Ahmedabad_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/jammu-kashmir-family-tour-packages"
            render={props => <Kashmir_7N_8D_Family_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/kashmir-package-tour-with-amritsar-katra-vaishno-devi-pahalgam-gulmarg-srinagar-sonmarg"
            render={props => <Kashmir_9N_10D_Vaishno_Devi_Amritsar_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/Kashmir-Leh-Ladakh-Tour-Package"
            render={props => <Kashmir_Leh_Ladakh_Tour_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/Ladakh-Tour-Package"
            render={props => <Ladakh_6N_7D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/Leh-Ladakh-Kargil-Package-Tour"
            render={props => <Leh_Ladakh_Kargil_8N_9D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/Leh-Ladakh-Turtuk-Package-Tour-from-Mumbai-with-Flight"
            render={props => <Leh_Ladakh_Turtuk_Page {...props} key={Date.now()} />}
          />
           <Route
            exact
            path="/ladakh-package-tour-from-mumbai"
            render={props => <Ladakh_7N_8D_Mumbai_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/Thailand-Tour-Package-from-kolkata-Airport"
            render={props => <Thailand_8N_9D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/bangkok-pattaya-thailand-holiday-package-tour-from-india"
            render={props => <BangkokPattaya_8N_9D_Page {...props} key={Date.now()} />}
          />

          <Route
            exact
            path="/Vietnam-Tour-Package"
            render={props => <Vietnam_7N_8D_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/vietnam-package-tour-from-kolkata"
            render={props => <Vietnam_7N_8D_Kolkata_Page {...props} key={Date.now()} />}
          />
          {/* ----------------Egypt Tour Package--------------------- */}
          <Route
            exact
            path="/egypt-package-tour-from-kolkata-8night-9days"
            render={props => <Egypt_8N_9D_Page {...props} key={Date.now()} />}
          />
          {/* ----------------Sundarban Tour Package--------------------- */}
          <Route
            exact
            path="/sundarban-package-tour-from-kolkata-with-hotel-sonar-bangla"
            render={props => <SundarbanTourPage_Sonarbangla {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sundarban-package-tour-from-kolkata"
            render={props => <SundarbanTourPage_Kolkata {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sandakphu-trekking-package-booking"
            render={props => <Sandakphu_trekking_Page {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/sandakphu-land-rover-package-tour-booking"
            render={props => <Sandakphu_land_rover_Page {...props} key={Date.now()} />}
          />
          {/*------------------------------ Sri Lanka Start */}
          <Route
            exact
            path="/srilanka-package-tour-from-kolkata"
            render={props => <SrilankaKolkataPage {...props} key={Date.now()} />}
          />
          {/*------------------------------------- dubai */}
          <Route
            exact
            path="/dubai-package-tour-from-kolkata"
            render={props => <DubaiKolkataPage {...props} key={Date.now()} />}
          />
          {/* <Route
            exact
            path="/customer-reg"
            render={props => <CustomerRegistrationPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/provider-reg"
            render={props => <ProviderRegistrationPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/login"
            render={props => <LoginPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/verifyotp/:mobileNo"
            render={props => <VerifyOTPPage {...props} key={Date.now()} />}
          />  */}
          {/* <Route
            exact
            path="/login"
            render={props => <UserOnboardPage {...props} key={Date.now()} />}
          />*/}

        </Switch>
      </Fragment>
    );
  }
}

export default AppRoute;
